module.exports = __webpack_public_path__ + "img/shape.70301cbf.png";